module.exports = __webpack_public_path__ + "media/images/companies/fujitsu-bad58303356aae852c037a9eaede977a.png";